export const accountTypeColors = {
  Family: "orange",
  Individual: "purple",
  Community: "warning",
} as const;

export const accountSetupStatusColors = {
  not_started: "gray",
  in_progress: "warning",
  completed: "success",
} as const;

export function formatSetupStatus(status: string): string {
  return status.replace(/_/g, " ");
}
